<template>
  <div>
    <template v-if="category && category.length > 0">
      <div class="caption">
        {{ category[0].name }}
      </div>
      <template v-for="(opt, oindex) in category[0].option">
        <product-option-item
          v-model="value"
          :option="opt"
          :key="'option_0_' + oindex"
          @onClick="
            option1 = opt
            onChangeOption()
          "
          :stock="stock"
          :level="0"
          :isSelected="option1 && option1 == opt"
        >
          <div slot="text">
            {{ opt }}
          </div>
        </product-option-item>
      </template>
      <template v-if="category.length > 1">
        <div class="caption">
          {{ category[1].name }}
        </div>

        <template v-for="(opt, oindex) in category[1].option">
          <product-option-item
            v-model="value"
            :option="opt"
            :key="'option_1_' + oindex"
            @onClick="
              option2 = opt
              onChangeOption()
            "
            :stock="stock"
            :level="1"
            :isSelected="option2 && option2 == opt"
          >
            <div slot="text">
              {{ opt }}
            </div>
          </product-option-item>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProductOptionItem from './ProductOptionItem'
export default {
  props: ['value', 'category', 'stock'],
  computed: {
    ...mapGetters({})
  },
  components: {
    ProductOptionItem
  },
  data() {
    return {
      option1: null,
      option2: null
    }
  },
  mounted() {
    try {
      var options = this.value[1].split('/')
      this.option1 = options && options.length > 0 ? options[0] : null
      this.option2 = options && options.length > 1 ? options[1] : null
    } catch (error) {
      //
    }
  },
  methods: {
    onChangeOption() {
      if (this.category.length > 1) {
        if (this.option1 && this.option2) {
          this.$emit('input', `${this.option1}/${this.option2}`)
          this.$emit('changeOption', `${this.option1}/${this.option2}`)
        } else {
          this.$emit('input', null)
          this.$emit('changeOption', null)
        }
      } else {
        this.$emit('input', this.option1 ? this.option1 : null)
        this.$emit('changeOption', this.option1 ? this.option1 : null)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ProductOption.vue